import { useEffect, useState } from "react";
// import axios from 'axios';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import "dayjs/locale/nl";
import "./Home.css";
// import Cards from '../../components/Cards';
import DiscoverEvent from "../../components/DiscoverEvent";
import SearchBar from "../../components/SearchBar";
import React from "react";
import { supabase } from "../../supabaseClient";
import LanguageIcon from "../../assets/Language.svg";
import TopBar from "../../components/TopBar";
import { useTranslation } from "react-i18next";
import SpinWinEventSection from "../../components/SpinWinEventSection";
import { useSelector } from "react-redux";
import { selectUser } from "../../slices/userReducer";
import { trackPageViewAnalytics } from "../../utils/visitorTracking";

export const CustomSelect = ({ options, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    onSelect(option); // Propagate the selected option to the parent component
    setIsOpen(false); // Close the dropdown
  };

  return (
    <div className="">
      <button
        className="flex justify-between items-center w-full"
        onClick={handleToggleDropdown}
      >
        {/* {selectedOption ? selectedOption.label : "Select an option"} */}
        <img
          src={LanguageIcon}
          className="w-12 h-12 text-white"
          alt="Language Icon"
        />
      </button>
      {isOpen && (
        <ul className="right-[50px] z-10 absolute bg-[#130826] m-0 p-0 rounded-[10px] w-64 list-none">
          {options.map((option) => (
            <li
              key={option.value}
              onClick={() => handleOptionClick(option.value)}
              className="px-4 py-2 text-white cursor-pointer"
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

dayjs.extend(utc);
dayjs.extend(timezone);

const SpinWinPage = ({
  token,
  eventData,
  genres,
  eventsLoading,
  setEventsLoading,
  language,
  setLanguage,
}) => {
  const queryParams = new URLSearchParams(window.location.search);

  // Fix localStorage "All_cities" issue
  useEffect(() => {
    const storedCity = localStorage.getItem("city");
    if (storedCity === "All_cities") {
      localStorage.setItem("city", "all_cities");
    }
  }, []);

  const getDefaultCity = () => {
    // For SpinWinPage, always default to all_cities regardless of URL params or localStorage
    return "all_cities";
  };

  const [filters, setFilters] = useState({
    datum: "Alle Datums",
    categorie: "Alle events",
    genre: [],
    leeftijd: "Alle leeftijden",
    city: "all_cities",
    cities: [], // Empty array means show all cities
  });

  const [currentCity, setCurrentCity] = useState("all_cities");
  const [isSearchActive, setIsSearchActive] = useState(false);

  const [currentNetherlandsTime, setCurrentNetherlandsTime] = useState(() => {
    const netherlandsTime = new Date().toLocaleString("en-US", {
      timeZone: "Europe/Amsterdam",
    });

    return netherlandsTime;
  });

  const formattedCurrentDate = dayjs(currentNetherlandsTime).format(
    "YYYY-MM-DD HH:mm:ss"
  );

  // Get the current user
  const user = useSelector(selectUser);

  // Add this near the top of your Home component, after other state declarations
  const [tokenDefaultFiltersApplied, setTokenDefaultFiltersApplied] =
    useState(false);

  const [hasScrolled, setHasScrolled] = useState(false);

  // Track page view analytics
  useEffect(() => {
    trackPageViewAnalytics('SPIN_WIN', user?.id || null);
  }, [user?.id]);

  useEffect(() => {
    console.log("queryParams", queryParams);
    // For SpinWinPage, always keep "all_cities" as default regardless of URL params
    setCurrentCity("all_cities");
    setFilters((prev) => ({
      ...prev,
      city: "all_cities",
      cities: [], // Empty array means show all cities
    }));
  }, [queryParams]);

  useEffect(() => {
    console.log("currentCity", currentCity);
  }, [currentCity]);

  useEffect(() => {
    supabase
      .from("City")
      .select("*")
      .then(({ data, error }) => {
        if (error) {
          console.error(error);
        }
      });

    const timer = setInterval(() => {
      setCurrentNetherlandsTime(() => {
        const netherlandsTime = new Date().toLocaleString("en-US", {
          timeZone: "Europe/Amsterdam",
        });
        return netherlandsTime;
      }); // Update current date and time
    }, 1000); // Update every second (adjust as needed)

    return () => {
      clearInterval(timer); // Clean up the timer when the component unmounts
    };
  }, []);

  useEffect(() => {
    // setFilteredData(eventData);
    if (eventData.length > 0) {
      setEventsLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData, filters, currentCity]);

  // Add this useEffect to fetch and apply token default filters
  useEffect(() => {
    // Only run this once and only if we have a user with a token
    if (
      !tokenDefaultFiltersApplied &&
      user &&
      user.token &&
      !localStorage.getItem("userSetFilters")
    ) {
      const fetchTokenDefaultFilters = async () => {
        try {
          const { data, error } = await supabase
            .from("Token")
            .select("default_filters")
            .eq("name", user.token)
            .single();

          if (error) {
            console.error("Error fetching token default filters:", error);
            return;
          }

          if (data && data.default_filters) {
            // Parse the default filters
            const defaultFilters = data.default_filters;

            // Update city in localStorage if specified
            if (defaultFilters.city) {
              localStorage.setItem("city", defaultFilters.city);
              setCurrentCity(defaultFilters.city);
            }

            // Handle genres properly
            let genreValue = [];
            console.log("Applying genres:", defaultFilters.genre);
            if (defaultFilters.genre) {
              // Ensure genre is always handled as an array
              if (Array.isArray(defaultFilters.genre)) {
                genreValue = defaultFilters.genre;
              } else if (typeof defaultFilters.genre === "string") {
                // Handle case where genre might be a comma-separated string
                genreValue = defaultFilters.genre
                  .split(",")
                  .map((g) => g.trim());
              }
              console.log("genrevalue:", genreValue);
            }

            // Apply the filters
            setFilters((prev) => ({
              datum: defaultFilters.datum || prev.datum,
              categorie: defaultFilters.categorie || prev.categorie,
              genre: genreValue,
              leeftijd: defaultFilters.leeftijd || prev.leeftijd,
              city: defaultFilters.city || prev.city,
            }));

            // Mark that we've applied token filters
            setTokenDefaultFiltersApplied(true);

          }
        } catch (err) {
          console.error("Error fetching token default filters:", err);
        }
      };

      fetchTokenDefaultFilters();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, tokenDefaultFiltersApplied]);

  // Add this logic to track when user sets their own filters
  useEffect(() => {
    // Track when a user actively changes filters
    if (!tokenDefaultFiltersApplied) return;

    // Save a flag that user has set their own filters
    localStorage.setItem("userSetFilters", "true");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const filterByDate = (
    arr,
    dateFilter = filters["datum"].toLocaleLowerCase()
  ) => {
    let filteredByDates = [];

    const filterStatus = dateFilter;
    // Ensure we're using the same timezone for all date comparisons
    const today = dayjs().tz("Europe/Amsterdam").locale(language);
    const tomorrow = today.add(1, "day");
    const startOfWeek = today.startOf("week");
    const endOfWeek = today.endOf("week");
    const startOfNextWeek = today.add(1, "week").startOf("week");
    const endOfNextWeek = today.add(1, "week").endOf("week");
    const startOfMonth = today.startOf("month");
    const endOfMonth = today.endOf("month");

    // Helper function to safely parse event datetime
    const parseEventDate = (event) => {
      if (!event.datetime) return null;

      // If it's a number, treat as Unix timestamp
      if (typeof event.datetime === "number") {
        return dayjs.unix(event.datetime).tz("Europe/Amsterdam");
      }

      // If it's a string that looks like a number, convert to number first
      if (typeof event.datetime === "string" && /^\d+$/.test(event.datetime)) {
        return dayjs.unix(parseInt(event.datetime, 10)).tz("Europe/Amsterdam");
      }

      // Otherwise try to parse as ISO date
      return dayjs(event.datetime).tz("Europe/Amsterdam");
    };

    switch (filterStatus) {
      case "vandaag":
      case "today": {
        filteredByDates = arr.filter((event) => {
          const eventDate = parseEventDate(event);
          if (!eventDate || !eventDate.isValid()) {
            console.log(`Invalid date for event: ${event.name}`);
            return false;
          }
          return eventDate.isSame(today, "day");
        });
        break;
      }
      case "morgen":
      case "tomorrow": {
        filteredByDates = arr.filter((event) => {
          const eventDate = parseEventDate(event);
          if (!eventDate || !eventDate.isValid()) return false;
          return eventDate.isSame(tomorrow, "day");
        });
        break;
      }
      case "deze week":
      case "this week": {
        filteredByDates = arr.filter((event) => {
          const eventDate = parseEventDate(event);
          if (!eventDate || !eventDate.isValid()) return false;
          return (
            eventDate.isAfter(startOfWeek) &&
            eventDate.isBefore(endOfWeek.add(1, "day"))
          );
        });
        break;
      }
      case "volgende week":
      case "next week": {
        filteredByDates = arr.filter((event) => {
          const eventDate = parseEventDate(event);
          if (!eventDate || !eventDate.isValid()) return false;
          return (
            eventDate.isAfter(startOfNextWeek) &&
            eventDate.isBefore(endOfNextWeek.add(1, "day"))
          );
        });
        break;
      }
      case "deze maand":
      case "this month": {
        filteredByDates = arr.filter((event) => {
          const eventDate = parseEventDate(event);
          if (!eventDate || !eventDate.isValid()) return false;
          return (
            eventDate.isAfter(startOfMonth) &&
            eventDate.isBefore(endOfMonth.add(1, "day"))
          );
        });
        break;
      }
      default:
        filteredByDates = arr;
        break;
    }

    return filteredByDates;
  };

  const filterByCategory = (arr) => {
    let filteredByCategory = [];
    const filterStatus = filters["categorie"].toLowerCase();
    switch (filterStatus) {
      case "dag event":
      case "day event":
        filteredByCategory = arr.filter(
          (event) =>
            event.event_type.toLowerCase() === "day event" ||
            event.event_type.toLowerCase() === "dag event"
        );
        break;
      case "nacht event":
      case "night event":
        filteredByCategory = arr.filter(
          (event) =>
            event.event_type.toLowerCase() === "night event" ||
            event.event_type.toLowerCase() === "nacht event"
        );
        break;
      case "festival":
        filteredByCategory = arr.filter(
          (event) => event.event_type.toLowerCase() === "festival"
        );
        break;
      default:
        filteredByCategory = arr;
        break;
    }

    return filteredByCategory;
  };

  const filterByGenre = (arr) => {
    const filterStatus = filters["genre"]?.map((genre) => genre.toLowerCase()); // array

    // If no genres are selected, return all events
    if (!filterStatus || filterStatus.length === 0) {
      return arr;
    }

    // Filter events that have at least one of the selected genres
    return arr.filter((event) => {
      if (!event.genres) return false;

      const eventGenres = event.genres
        .split(",")
        .map((genre) => genre.trim().toLowerCase());

      return eventGenres.some((eventGenre) =>
        filterStatus.includes(eventGenre.toLowerCase())
      );
    });
  };

  const filterByAge = (arr) => {
    let filteredByAge = [];
    const filterStatus = filters["leeftijd"];

    switch (filterStatus) {
      case "18+":
        filteredByAge = arr.filter((event) => +event.minimum_age <= 18);
        break;
      case "21+":
        filteredByAge = arr.filter(
          (event) => +event.minimum_age <= 21 && +event.minimum_age > 18
        );
        break;
      case "23+":
        filteredByAge = arr.filter(
          (event) => +event.minimum_age <= 23 && +event.minimum_age > 21
        );
        break;
      default:
        filteredByAge = arr; // "All ages" shows all events
        break;
    }
    return filteredByAge;
  };

  const filterByCity = (arr) => {
    let filteredByCity = [];

    // Handle both array (filters.cities) and string (filters.city) cases
    const citiesArray = filters.cities || [];
    const singleCity = filters.city;

    if ((citiesArray.length === 0) || (singleCity && singleCity.toLowerCase() === "all_cities")) {
      // If no cities selected or explicitly set to all_cities, show all events
      filteredByCity = arr;
    } else if (citiesArray.length > 0) {
      // Filter by multiple cities (from DiscoverEvent component)
      filteredByCity = arr.filter((event) =>
        citiesArray.some(city => event.city.includes(city))
      );
    } else {
      // Filter by single city (from sidebar)
      filteredByCity = arr.filter((event) =>
        event.city.includes(singleCity)
      );
    }

    return filteredByCity;
  };

  const changeCity = (city) => {
    localStorage.setItem("city", city);
    // Mark that user has set their own filters
    localStorage.setItem("userSetFilters", "true");

    setFilters((prev) => ({
      ...prev,
      city: city,
      // Don't override cities array - let DiscoverEvent component manage multiple city selection
      // cities: city === "all_cities" ? [] : [city],
    }));
    setCurrentCity(city);
  };

  const { t } = useTranslation();

  // Helper function to display city text properly
  const getCityDisplayText = (cities) => {
    if (!cities || cities.length === 0) return t("all_cities");
    if (cities.length === 1) return cities[0];
    return t("multiple_cities", { count: cities.length });
  };

  useEffect(() => {
    // Try to detect scrolling in any element
    const handleScrollAnywhere = () => {
      // Get scroll position from the documentElement (most reliable cross-browser)
      const windowScroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      // Check if window is at the very top (0 position)
      if (windowScroll === 0) {
        // Only check containers if window is at the top
        const containers = document.querySelectorAll(".scroller");
        let containerScrolled = false;

        containers.forEach((container) => {
          if (container.scrollTop > 0) {
            containerScrolled = true;
          }
        });

        // If window is at top and no containers are scrolled, immediately set hasScrolled to false
        if (!containerScrolled) {
          setHasScrolled(false);
        }
      } else {
        // If window is scrolled, immediately set hasScrolled to true
        setHasScrolled(true);
      }
    };

    // Initial check
    handleScrollAnywhere();

    // Add multiple event listeners to catch all possible scroll events
    window.addEventListener("scroll", handleScrollAnywhere, { passive: true });
    document.addEventListener("scroll", handleScrollAnywhere, {
      passive: true,
    });

    // Force checking the scroll position at regular intervals
    const intervalId = setInterval(handleScrollAnywhere, 10);

    // Also apply a fallback class after some time has passed
    const timeoutId = setTimeout(() => {
      if (!hasScrolled) {
        setHasScrolled(true);
      }
    }, 5000);

    return () => {
      window.removeEventListener("scroll", handleScrollAnywhere);
      document.removeEventListener("scroll", handleScrollAnywhere);
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [hasScrolled]);

  return (
    <div className="relative bg-[#2a0744] min-h-screen">
      <div className="relative flex flex-col justify-center items-center bg-[#0B0415]">
        <div className="relative lg:w-[95%] max-lg:w-[100vw] max-w-[1400px]">
          <TopBar
            setLanguage={setLanguage}
            eventData={eventData}
            formattedCurrentDate={formattedCurrentDate}
          />
          <div
            className={`transition-all max-lg:pb-[20px] lg:py-[60px] ${
              hasScrolled ? "" : "max-lg:pt-[90px] "
            }`}
          >
            <div
              className={`max-lg:bg-[#12041f] transition-all max-lg:fixed max-lg:left-0 max-lg:right-0 max-lg:w-full flex items-center justify-between ${
                hasScrolled
                  ? "pt-[70px] max-lg:backdrop-blur-lg max-lg:z-[999]"
                  : ""
              }`}
            >
              <div className="flex justify-start items-center gap-3 max-lg:pb-2 max-lg:w-full max-lg:overflow-x-auto max-lg:scrollbar-hide">
                {/* Filters */}
                <DiscoverEvent
                  filters={filters}
                  setFilters={setFilters}
                  token={token}
                  city={currentCity}
                  genres={genres}
                  changeCity={changeCity}
                />
              </div>
              <div className="max-lg:hidden flex justify-end items-center gap-3">
                {/* Search Bar */}
                <SearchBar
                  eventData={eventData}
                  formattedCurrentDate={formattedCurrentDate}
                  onSearchDismiss={() => {}}
                  isSearchActive={isSearchActive}
                  setIsSearchActive={setIsSearchActive}
                />
              </div>
            </div>
            <h1 className="max-lg:px-[16px] pt-[60px] lg:pt-[60px] w-full text-[36px] text-white lg:text-[72px] text-start leading-[40px] lg:leading-[80px]">
              {t("spin_and_win_tickets")} in <br className="max-lg:hidden" />
              <span className="text-[#C9A6F5]">
                {getCityDisplayText(filters.cities)}
              </span>
            </h1>
          </div>
          <hr className="right-0 left-0 absolute border-[#AD7AEF80] border-r w-full" />
        </div>

        <div
          className="flex justify-center w-full min-h-[66.6vh] scroller"
          style={{
            background:
              "linear-gradient(to bottom, #0B0415 0%, #1d0630 40vh, #2a0744 60vh)",
          }}
        >
          <div className="mb-[40px] lg:w-[95%] max-lg:w-[100vw] max-w-[1400px]">
            <h2 className="max-lg:hidden max-lg:!px-[16px] pt-[50px] text-white">
              {t("discover_events")}
            </h2>
            <SpinWinEventSection
              formattedCurrentDate={formattedCurrentDate}
              filters={filters}
              currentCity={currentCity}
              filterFunctions={{
                filterByDate,
                filterByCategory,
                filterByGenre,
                filterByAge,
                filterByCity,
              }}
              showBanner={true}
              isCarousel={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default SpinWinPage;
